<script>
import Modal from "@/components/g-modal.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    Modal
  },
  props: {
    opened: Boolean,
    /** @type Participant[]
     *  Este são os participantes já vinculados ao sistema
     */
    participants: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      /** @type Participant[] */
      unattachedParticipants: [],
      innerOpened: this.opened,
      /** @type {string} */
      search: "",
      selection: []
    };
  },
  computed: {
    ...mapGetters(["clientId"]),
    disabledAttatchBtn() {
      return !this.selection.length;
    },
    headers() {
      return [
        { text: "", value: "selection", align: "center", sortable: false },
        { text: "Categoria", value: "tipo_participante_label", width: "200px" },
        { text: "Budget Key", value: "budget_key", width: "200px" },
        { text: "Matrícula", value: "matricula", width: "200px" },
        { text: "Participante", value: "nome" }
      ];
    }
  },
  watch: {
    innerOpened(value) {
      this.$emit("update:opened", value);
    },
    opened(value) {
      if (value !== this.innerOpened) {
        this.innerOpened = value;

        if (value) {
          this.getAllParticipants();
        }
      }
    }
  },
  created() {
    if (this.opened) {
      this.getAllParticipants();
    }
  },
  methods: {
    close() {
      this.selection = [];
      this.search = "";
      this.innerOpened = false;
    },
    doAttatch() {
      this.$emit(
        "save",
        this.selection.map(({ id }) => id),
        this.close
      );
    },
    async getAllParticipants() {
      try {
        const resource = this.apiResource(
          `v1/ativacaoped/${this.clientId}/participantes/selecao`
        );
        const response = await resource.get();
        const attatchedIds = this.participants.map(({ id }) => id);

        this.unattachedParticipants = response.data
          .filter(({ id }) => !attatchedIds.includes(id))
          .map(participant => {
            const {
              budget_key,
              email,
              matricula,
              nome,
              perfil,
              tipo_participante_label
            } = participant;

            return {
              ...participant,
              budget_key: budget_key?.posicao || "Sem BK",
              matricula: matricula ?? "Sem matricula",
              nome:
                nome ??
                email ??
                `${perfil?.senioridade ||
                  "Sem senioridade"} - ${perfil?.especialidade ||
                  "Sem especialidade"}`,
              tipo_participante_label
            };
          })
          .sort(
            (a, b) =>
              (a.tipo_participante_label || "").localeCompare(
                b.tipo_participante_label || ""
              ) || (a.nome || "").localeCompare(b.nome || "")
          );
      } catch (error) {
        this.unattachedParticipants = [];

        if (error.isAxiosError) {
          this.notify(error);
        }
      }
    }
  }
};
</script>

<template>
  <Modal
    v-model="innerOpened"
    appendTitleIcon="mdi-link-plus"
    contentClass="participants-attach-modal"
    title="Vincular participantes"
    @close="close"
  >
    <v-data-table
      v-model="selection"
      class="participants-attach-data-table"
      disable-pagination
      fixed-header
      :headers="headers"
      hide-default-footer
      :items="unattachedParticipants"
      :search="search"
      show-select
    >
      <template v-slot:top>
        <div class="sticky-top">
          <v-text-field
            v-model="search"
            class="search-field"
            clearable
            dense
            outlined
            placeholder="Filtrar..."
            prepend-inner-icon="mdi-filter-outline"
            hide-details
          ></v-text-field>
        </div>
      </template>
    </v-data-table>

    <template #buttons>
      <v-spacer />

      <v-btn class="px-5 ml-3" color="secondary" depressed @click="close">
        Cancelar
      </v-btn>

      <v-btn
        class="px-5 ml-3"
        color="primary"
        :dark="!disabledAttatchBtn"
        depressed
        :disabled="disabledAttatchBtn"
        @click="doAttatch"
      >
        Vincular
      </v-btn>
    </template>
  </Modal>
</template>

<style lang="scss">
.participants-attach-modal {
  & > .v-card > .v-card__text {
    padding: 0;
    overflow: hidden;
  }
}
</style>

<style lang="scss" scoped>
.search-field {
  margin: 0;
}

.participants-attach-data-table {
  display: flex;
  flex-direction: column;
  max-height: 60vh;

  &::v-deep .v-data-table__wrapper {
    flex: 1;

    .tbody {
      flex: 1;
      overflow-y: auto;
    }
  }
}

.sticky-top {
  flex: 0;
  background: white;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>
